import en from "./en.json";

const availableLocales = {
  en,
};

export const locales = Object.fromEntries(
  Object.entries(availableLocales).map(([locale, translations]) => [
    locale,
    Object.fromEntries(
      Object.entries(translations).filter(([_key, value]) => value)
    ),
  ])
);
